export default __webpack_public_path__ + "static/media/BS03.86b653c7.jpg";